var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarDateEventScheduleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.8,
    height: 12.8,
    viewBox: "0 0 12.8 12.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_510869_calendar_date_event_schedule_icon",
    "data-name": "510869_calendar_date_event_schedule_icon",
    transform: "translate(-15 -15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_22053",
    "data-name": "Path 22053",
    d: "M26.52,16.28H25.24V15H23.96v1.28H18.84V15H17.56v1.28H16.28A1.28,1.28,0,0,0,15,17.56v8.96a1.28,1.28,0,0,0,1.28,1.28H26.52a1.28,1.28,0,0,0,1.28-1.28V17.56A1.28,1.28,0,0,0,26.52,16.28Zm0,10.24H16.28v-6.4H26.52Zm0-7.68H16.28V17.56H26.52Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5933",
    "data-name": "Rectangle 5933",
    width: 1.166,
    height: 1.166,
    transform: "translate(21.4 21.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5934",
    "data-name": "Rectangle 5934",
    width: 1.166,
    height: 1.166,
    transform: "translate(23.732 21.4)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5935",
    "data-name": "Rectangle 5935",
    width: 1.166,
    height: 1.166,
    transform: "translate(21.4 23.732)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5936",
    "data-name": "Rectangle 5936",
    width: 1.166,
    height: 1.166,
    transform: "translate(19.068 23.732)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDateEventScheduleIcon);
export default __webpack_public_path__ + "static/media/calendar_date_event_schedule_icon.d05cb91032b645ece0755ce077e0a476.svg";
export { ForwardRef as ReactComponent };